import { Box, Card, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getPatientQuestionAnswer } from "../../../PatientApiActions";
import QuestionAnswer from "./QuestionAnswer";
import { useStyles } from "../styles";

const PatientAnswers = ({
  type,
  patientId,
  getPatientQuestionAnswer,
  emptyMessage,
  // Optional case-insensitive substring filters on the question text:
  // `matchQuestions` keeps only questions matching one of the entries,
  // `excludeQuestions` drops any question matching one of the entries.
  matchQuestions,
  excludeQuestions,
  // When true, render nothing (instead of the empty message) if no questions
  // remain — used when several filtered instances share one section.
  hideWhenEmpty,
}) => {
  const classes = useStyles();
  const [patientQuestionAnswer, setPatientQuestionAnswer] = React.useState([]);

  const matchesAny = (text, patterns) =>
    patterns.some((p) => text.toLowerCase().includes(p.toLowerCase()));
  const parseCheckboxAnswer = (answer, question_values) => {
    if (!Array.isArray(answer) || answer.length === 0) return [];

    const answerElement = answer[0];
    let indices = [];

    if (typeof answerElement === "string") {
      indices = answerElement.split(",").map((i) => parseInt(i.trim(), 10));
    } else if (typeof answerElement === "number") {
      indices = answer.map((i) => parseInt(i, 10));
    }

    return indices
      .filter((i) => !isNaN(i) && question_values[i] !== undefined)
      .map((i) => question_values[i]);
  };

  useEffect(() => {
    if (patientId && type) {
      getPatientQuestionAnswer(type, patientId).then((res) => {
        const updatedQuestionAnswerList = res
          .filter(
            (item) =>
              item.answer !== null &&
              item.answer !== "" &&
              item.answer !== -1 &&
              item.answer !== "-1"
          )
          .map((item) => {
            const { question_text, question_values, option_type } =
              item.attributes;
            let parsedAnswer = [];

            if (option_type === "Single_Select") {
              const index = Number(item.answer[0]);
              if (!isNaN(index) && question_values[index]) {
                parsedAnswer = [question_values[index]];
              }
            } else if (option_type === "Checkbox_Search") {
              parsedAnswer = parseCheckboxAnswer(item.answer, question_values);
            }

            return {
              id: item.id,
              text: toTitleCase(question_text),
              userAnswer: parsedAnswer,
            };
          })
          .filter((question) => {
            if (
              Array.isArray(matchQuestions) &&
              matchQuestions.length > 0 &&
              !matchesAny(question.text, matchQuestions)
            )
              return false;
            if (
              Array.isArray(excludeQuestions) &&
              excludeQuestions.length > 0 &&
              matchesAny(question.text, excludeQuestions)
            )
              return false;
            return true;
          });

        setPatientQuestionAnswer(updatedQuestionAnswerList);
      });
    }
  }, [patientId, type, matchQuestions, excludeQuestions]);

  const toTitleCase = (str) => {
    return str
      .toLowerCase()
      .split("_")
      .join(" ")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  if (hideWhenEmpty && patientQuestionAnswer.length === 0) return null;

  return (
    <Box pt={2}>
      <Card>
        <Box p={2}>
          {patientQuestionAnswer.length === 0 ? (
            <Box className={classes.noContentContainer}>
              <Typography className={classes.noLabel}>
                {emptyMessage || "No health information available."}
              </Typography>
            </Box>
          ) : (
            patientQuestionAnswer.map((question) => (
              <Box key={question.id} mb={2}>
                <Typography
                  variant="subtitle1"
                  className={classes.questionText}
                >
                  {question.text}
                </Typography>

                {/* Render multiple answers as list or chips */}
                <Box mt={1} display="flex" flexWrap="wrap" gap={1}>
                  {question.userAnswer.map((ans, index) => (
                    <Typography
                      key={index}
                      variant="body2"
                      className={classes.answerText}
                    >
                      • {toTitleCase(ans)}
                    </Typography>
                  ))}
                </Box>
              </Box>
            ))
          )}
        </Box>
      </Card>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    patient: state.athletes.athlete,
    patientQuestionAnswer: state.patientQuestionAnswer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPatientQuestionAnswer: (type, userId) => {
      return dispatch(getPatientQuestionAnswer(type, userId)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientAnswers);
